import ClaimsService from './ClaimsService';
import Auth0Lock from 'auth0-lock';
import decodeJwt from 'jwt-decode';
import moment from 'moment';
import request from './request';
import appConfig from '../config/appConfig';

const clientId = 'Qn6k_GnXafrGEu2WzcWAzUATqkvW0yeD';
const domain = 'gemeindepark.eu.auth0.com';

const ACCESS_TOKEN = 'gemeindepark.accessToken';
const USER_NAME = 'auth0.name';
const USER_EMAIL = 'auth0.email';
const ROLES = 'auth0.custom.roles';
const ROLE_OVERRIDE = 'auth0.custom.overriderolename';

const lock = new Auth0Lock(clientId, domain, {
  closable: false,
  language: 'de',

  auth: {
    audience: "Gemeindepark",
    redirectUrl: `${appConfig.loginServiceUrl}login`,
    responseType: 'token',
    responseMode: 'form_post',
    params: {
      scope: 'openid profile email lagerpark', // Learn about scopes: https://auth0.com/docs/scopes
      state: Buffer.from(`${window.location.protocol}//${window.location.host}`).toString('base64')
    }
  }
});


let claimsService = new ClaimsService(getRoles());

function setTokenData(accessToken) {
  const profile = decodeJwt(accessToken);

  localStorage.setItem(ACCESS_TOKEN, accessToken);
  localStorage.setItem(USER_NAME, profile['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']);
  localStorage.setItem(USER_EMAIL, profile['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress']);

  const roles = profile['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
  localStorage.setItem(ROLES, JSON.stringify(roles));
  claimsService.refresh(roles);
}

function getRoles() {
  const roles = localStorage.getItem(ROLES);
  if(!roles) {
    return [];
  }

  try {
    return JSON.parse(roles);
  } catch (e) {
    return [];
  }
}

function isUserWhitelisted() {
  return getRoles().length > 0;
}

function getTokenDataFromCache() {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);

  let tokenData = {
    accessToken,
    name: localStorage.getItem(USER_NAME),
    email: localStorage.getItem(USER_EMAIL),
    isAuthenticated: !!accessToken
  };

  return tokenData;
}

function clearCache() {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(USER_NAME);
  localStorage.removeItem(USER_EMAIL);
  localStorage.removeItem(ROLES);
  localStorage.removeItem(ROLE_OVERRIDE);
}

function isAuthenticated() {
  return getTokenDataFromCache().isAuthenticated;
}

function getTokenExpirationDate() {
  const token = getAccessToken();
  const expirationTimestamp = decodeJwt(token).exp;
  const expirationDate = moment(expirationTimestamp * 1000);

  return expirationDate;
}

function getAccessToken() {
  var auth0Data = getTokenDataFromCache();

  if (auth0Data.isAuthenticated) {
    return auth0Data.accessToken;
  }

  clearCache();

  return null;
}

function logout() {
  clearCache();
  claimsService.refresh(getRoles());
}

function hasClaim(claim) {
  return claimsService.hasClaim(claim);
}

function getOverrideRoleName() {
  return localStorage.getItem(ROLE_OVERRIDE) || '';
}

function setOverrideRoleName(roleName) {
  request.post({
    url: `${appConfig.loginServiceUrl}login/refresh?overrideRole=${roleName}`,
      success: response => {
        setTokenData(response.token);
        localStorage.setItem(ROLE_OVERRIDE, roleName);

        window.location.reload();
      }
  });
}

export default {
  lock,
  getAccessToken,
  isAuthenticated,
  logout,
  getTokenDataFromCache,
  setTokenData,
  getRoles,
  isUserWhitelisted,
  getOverrideRoleName,
  setOverrideRoleName,
  getTokenExpirationDate,
  hasClaim
};



// WEBPACK FOOTER //
// ./src/helpers/auth0.js